import { LangSelectProfile } from 'config';
import { Colors, Shadows } from 'enums';
import { StylesConfig } from 'react-select';

export const languageStyleCustom: StylesConfig<LangSelectProfile> = {
  container: (base) => ({
    ...base,
    width: '100%',
    fontFamily: 'Inter, sans-serif',
    fontSize: 16,
    cursor: 'pointer',
    textAlign: 'left',
    boxShadow: 'none',
  }),
  control: (base, { menuIsOpen }) => ({
    ...base,
    height: 56,
    padding: '12px',
    backgroundColor: Colors.white,
    borderRadius: 10,
    cursor: 'pointer',
    border: `1px solid ${menuIsOpen ? Colors.yellow1 : 'transparent'}`,
    boxShadow: 'none',
    '&:hover': {
      border: `1px solid ${menuIsOpen ? Colors.yellow1 : 'transparent'}`,
      backgroundColor: Colors.gray5,
    },
  }),
  menu: (base) => ({
    ...base,
    borderRadius: 10,
    border: 'none',
    boxShadow: Shadows.darkShadow,
  }),
  menuList: (base) => ({
    ...base,
    borderRadius: 10,
    '::-webkit-scrollbar': {
      width: 4,
    },
    '::-webkit-scrollbar-thumb': {
      background: Colors.yellow1,
      borderRadius: 2,
    },
    '::-webkit-scrollbar-thumb:hover': {
      background: Colors.yellow2,
    },
  }),
  singleValue: (base) => ({
    ...base,
    height: '100%',
  }),
  valueContainer: (base) => ({
    ...base,
    padding: 0,
    input: {
      height: '100%',
    },
  }),
  option: (base) => ({
    ...base,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: '56px',
    backgroundColor: Colors.white,
    color: Colors.gray1,
    padding: '18px 24px',
    cursor: 'pointer',
    '&:active': {
      backgroundColor: 'transparent',
    },
    '&:hover': {
      backgroundColor: Colors.background,
    },
  }),
};
